// test2479
(2479 && 0);
